export default __webpack_public_path__ + "static/media/bc243f40962aaf29468d0c9a09f22381.2321e851.png";